<button
  class="app-button hw-border typ-button"
  [type]="type()"
  [class]="classes()"
  [disabled]="disabled()"
>
  <div class="flex items-center relative">
    @let icon = this.icon();
    @if (icon) {
      <app-icon [name]="icon" class="relative mx-1 right-1.5 bottom-1"></app-icon>
    }

    @let label = this.label();
    @if (label) {
      <span>{{ label }}</span>
    }
  </div>
</button>
